import type { IconProps } from './types';

export const ScoreWeightsIcon = (props: IconProps) => {
  const { size = 16, ref, color: _color, ...other } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" ref={ref} {...other}>
      <rect x="1" y="1" width="6.6" height="6.6" rx="1" fill="#EE46BC" />
      <rect x="8.4" y="1" width="6.6" height="6.6" rx="1" fill="#7A5AF8" />
      <rect x="1" y="8.4" width="6.6" height="6.6" rx="1" fill="#0BA5EC" />
      <rect x="8.4" y="8.4" width="6.6" height="6.6" rx="1" fill="#D444F1" />
    </svg>
  );
};
